"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listJobOfferComplianceRules = exports.toJobOfferComplianceTexts = exports.JOB_OFFER_COMPLIANCE_CHECK_AI_BUDGET_MS = exports.JOB_OFFER_COMPLIANCE_RULES = exports.JOB_OFFER_COMPLIANCE_VERDICT_OUTCOMES = exports.JOB_OFFER_COMPLIANCE_ISSUE_FIELDS = exports.JOB_OFFER_COMPLIANCE_FIELDS = void 0;
const lib_custom_types_1 = require("@backend/lib-custom-types");
exports.JOB_OFFER_COMPLIANCE_FIELDS = (0, lib_custom_types_1.strictUnionArray)()([
    'title',
    'introduction',
    'about',
    'prerequisites',
    'bonuses',
]);
exports.JOB_OFFER_COMPLIANCE_ISSUE_FIELDS = (0, lib_custom_types_1.strictUnionArray)()([
    ...exports.JOB_OFFER_COMPLIANCE_FIELDS,
    'requiredCertificates',
]);
exports.JOB_OFFER_COMPLIANCE_VERDICT_OUTCOMES = (0, lib_custom_types_1.strictUnionArray)()([
    'COMPLIANT',
    'CORRECTED',
    'BYPASSED',
]);
exports.JOB_OFFER_COMPLIANCE_RULES = (0, lib_custom_types_1.strictUnionArray)()([
    'GENDER',
    'HEALTH',
    'PERMANENT_CONTRACT',
    'EQUIPMENT',
    'DRIVING_LICENSE_B',
    'AGE',
    'STATUS',
    'CRIMINAL_RECORD',
    'APPEARANCE',
    'DISABILITY',
    'RESIDENCE',
    'BROKEN_WORD',
]);
exports.JOB_OFFER_COMPLIANCE_CHECK_AI_BUDGET_MS = 20_000;
const toJobOfferComplianceTexts = (texts) => Object.fromEntries(exports.JOB_OFFER_COMPLIANCE_FIELDS.flatMap(field => {
    const text = texts[field]?.trim();
    return text ? [[field, text]] : [];
}));
exports.toJobOfferComplianceTexts = toJobOfferComplianceTexts;
const listJobOfferComplianceRules = (issues) => [
    ...new Set(issues.map(({ rule }) => rule)),
];
exports.listJobOfferComplianceRules = listJobOfferComplianceRules;
